const cryptocurrency = {
  paymentMethodName: 'العملة المشفرة',
  cryptocurrencyLabel: 'العملة المشفرة',
  cryptocurrencySelectPlaceholder: 'اختر عملتك المشفرة',
  protocolWarning: 'إذا تم الدفع باستخدام شبكة مختلفة عن المحددة، فقد تضيع الأموال بشكل دائم. يرجى <b>التأكد من أن محفظتك مُعدة للشبكة الصحيحة</b> قبل المتابعة.',
  networkLabel: 'الشبكة',
  networkSelectPlaceholder: 'اختر شبكتك',
  paymentButtonLabel: 'الدفع بالعملة المشفرة',
  amountLocal: 'المبلغ المحلي',
  amountCrypto: 'المبلغ بالعملة المشفرة',
  paymentCreatedTitle: 'تم إنشاء دفعتك!',
  paymentCreatedSubtitle: 'لن يستغرق الأمر وقتًا طويلاً حتى يكتمل طلبك! اتبع التعليمات أدناه لتأكيد هذه المعاملة.',
  qrCodeInstruction: 'امسح رمز الاستجابة السريعة التالي في محفظتك لإكمال الدفع في ثوانٍ قليلة فقط',
  qrCodeNetworkNotFound: 'الشبكة غير موجودة. تأكد من أنك حددت الشبكة الصحيحة.',
  networkWarning: 'أنت تدفع <b>{cryptocurrency}</b> باستخدام <b>{protocol}</b>. تأكد من اختيار الشبكة الصحيحة في محفظتك، وإلا قد تفقد أموالك.',
  conversionRate: 'القيمة المحولة هي 1 {currencyExt} = {formattedCryptoRate} {cryptocurrency}. يتم حساب هذه القيمة في الوقت الفعلي وقد تتقلب بناءً على سعر الصرف.',
  paymentApproved: 'تمت الموافقة على دفعتك بقيمة <AmountText>{amountLocal}</AmountText>.',
  howToPayInfoTitle: 'كيف تدفع بالعملة المشفرة؟',
  howToPayOpenApp: 'افتح محفظتك (تطبيق أو إضافة) واضغط على خيار الشراء أو التحويل أو الإرسال أو الدفع.',
  howToPayQrCode: 'امسح رمز الاستجابة السريعة واملأ الحقول المطلوبة باستخدام النسخ واللصق.',
  howToPayNetwork: 'تأكد من اختيار الشبكة الصحيحة. إذا تم اختيار الشبكة الخطأ، قد لا يمكن استرداد الأموال.',
  howToPayConfirmation: 'تتبع الحالة في محفظتك (النشاط/السجل) أو عد إلى هذه الصفحة لانتظار التأكيد.',
  payAgreement1: 'عند الدفع، فإنك توافق على ',
  serviceTerms: 'شروط الخدمة',
  payAgreement2: ' الخاصة بـ EBANX.',
  payWithWalletButton: 'الدفع بمحفظة العملات المشفرة',
  walletRedirectInstruction: 'يمكنك الدفع بالنقر على الزر وسيتم إعادة توجيهك لإتمام الدفع.',
  manualQrCodeInstruction: 'أو امسح رمز QR أدناه يدويًا لمتابعة الدفع',
};

module.exports = cryptocurrency;
